import gql from 'graphql-tag';
import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Euler = {
  __typename?: 'Euler';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type InputEuler = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type InputVector3 = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type Mutation = {
  __typename?: 'Mutation';
  captureFlag: Scalars['Boolean'];
  onlineObject: OnlineObject;
};


export type MutationCaptureFlagArgs = {
  playerId: Scalars['String'];
  flagId: Scalars['String'];
};


export type MutationOnlineObjectArgs = {
  id: Scalars['String'];
  position: InputVector3;
  rotation: InputEuler;
  name?: Maybe<Scalars['String']>;
  team?: Maybe<Scalars['String']>;
};

export type OnlineObject = {
  __typename?: 'OnlineObject';
  id: Scalars['String'];
  position: Vector3;
  rotation: Euler;
  type: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  team?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  onlineObjects: Array<OnlineObject>;
  score: Score;
};


export type QueryOnlineObjectsArgs = {
  id?: Maybe<Scalars['String']>;
};

export type Score = {
  __typename?: 'Score';
  red: Scalars['Int'];
  blue: Scalars['Int'];
};

export type Subscription = {
  __typename?: 'Subscription';
  objectsUpdated?: Maybe<Array<OnlineObject>>;
};

export type Vector3 = {
  __typename?: 'Vector3';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

export type CaptureFlagMutationVariables = Exact<{
  playerId: Scalars['String'];
  flagId: Scalars['String'];
}>;


export type CaptureFlagMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'captureFlag'>
);

export type GetAllObjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllObjectsQuery = (
  { __typename?: 'Query' }
  & { onlineObjects: Array<(
    { __typename?: 'OnlineObject' }
    & Pick<OnlineObject, 'id' | 'type' | 'name'>
    & { position: (
      { __typename?: 'Vector3' }
      & Pick<Vector3, 'x' | 'y' | 'z'>
    ), rotation: (
      { __typename?: 'Euler' }
      & Pick<Euler, 'x' | 'y' | 'z'>
    ) }
  )> }
);

export type SubscribeToAllObjectsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubscribeToAllObjectsSubscription = (
  { __typename?: 'Subscription' }
  & { objectsUpdated?: Maybe<Array<(
    { __typename?: 'OnlineObject' }
    & Pick<OnlineObject, 'type'>
    & { position: (
      { __typename?: 'Vector3' }
      & Pick<Vector3, 'x' | 'y' | 'z'>
    ) }
  )>> }
);

export type GetPlayerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetPlayerQuery = (
  { __typename?: 'Query' }
  & { onlineObjects: Array<(
    { __typename?: 'OnlineObject' }
    & Pick<OnlineObject, 'id' | 'team'>
    & { position: (
      { __typename?: 'Vector3' }
      & Pick<Vector3, 'x' | 'y' | 'z'>
    ), rotation: (
      { __typename?: 'Euler' }
      & Pick<Euler, 'x' | 'y' | 'z'>
    ) }
  )> }
);

export type MutateCurrentPlayerMutationVariables = Exact<{
  id: Scalars['String'];
  position: InputVector3;
  rotation: InputEuler;
  name: Scalars['String'];
  team?: Maybe<Scalars['String']>;
}>;


export type MutateCurrentPlayerMutation = (
  { __typename?: 'Mutation' }
  & { onlineObject: (
    { __typename?: 'OnlineObject' }
    & Pick<OnlineObject, 'type' | 'team'>
    & { position: (
      { __typename?: 'Vector3' }
      & Pick<Vector3, 'x' | 'y' | 'z'>
    ), rotation: (
      { __typename?: 'Euler' }
      & Pick<Euler, 'x' | 'y' | 'z'>
    ) }
  ) }
);

export type GetScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScoreQuery = (
  { __typename?: 'Query' }
  & { score: (
    { __typename?: 'Score' }
    & Pick<Score, 'red' | 'blue'>
  ) }
);


export const CaptureFlag = gql`
    mutation captureFlag($playerId: String!, $flagId: String!) {
  captureFlag(playerId: $playerId, flagId: $flagId)
}
    `;
export const GetAllObjects = gql`
    query getAllObjects {
  onlineObjects {
    id
    position {
      x
      y
      z
    }
    rotation {
      x
      y
      z
    }
    type
    name
  }
}
    `;
export const SubscribeToAllObjects = gql`
    subscription subscribeToAllObjects {
  objectsUpdated {
    position {
      x
      y
      z
    }
    type
  }
}
    `;
export const GetPlayer = gql`
    query getPlayer($id: String!) {
  onlineObjects(id: $id) {
    id
    position {
      x
      y
      z
    }
    rotation {
      x
      y
      z
    }
    team
  }
}
    `;
export const MutateCurrentPlayer = gql`
    mutation mutateCurrentPlayer($id: String!, $position: InputVector3!, $rotation: InputEuler!, $name: String!, $team: String) {
  onlineObject(
    id: $id
    position: $position
    rotation: $rotation
    name: $name
    team: $team
  ) {
    position {
      x
      y
      z
    }
    rotation {
      x
      y
      z
    }
    type
    team
  }
}
    `;
export const GetScore = gql`
    query getScore {
  score {
    red
    blue
  }
}
    `;

export const CaptureFlagDocument = gql`
    mutation captureFlag($playerId: String!, $flagId: String!) {
  captureFlag(playerId: $playerId, flagId: $flagId)
}
    `;
export const GetAllObjectsDocument = gql`
    query getAllObjects {
  onlineObjects {
    id
    position {
      x
      y
      z
    }
    rotation {
      x
      y
      z
    }
    type
    name
  }
}
    `;
export const SubscribeToAllObjectsDocument = gql`
    subscription subscribeToAllObjects {
  objectsUpdated {
    position {
      x
      y
      z
    }
    type
  }
}
    `;
export const GetPlayerDocument = gql`
    query getPlayer($id: String!) {
  onlineObjects(id: $id) {
    id
    position {
      x
      y
      z
    }
    rotation {
      x
      y
      z
    }
    team
  }
}
    `;
export const MutateCurrentPlayerDocument = gql`
    mutation mutateCurrentPlayer($id: String!, $position: InputVector3!, $rotation: InputEuler!, $name: String!, $team: String) {
  onlineObject(
    id: $id
    position: $position
    rotation: $rotation
    name: $name
    team: $team
  ) {
    position {
      x
      y
      z
    }
    rotation {
      x
      y
      z
    }
    type
    team
  }
}
    `;
export const GetScoreDocument = gql`
    query getScore {
  score {
    red
    blue
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    captureFlag(variables: CaptureFlagMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<CaptureFlagMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CaptureFlagMutation>(CaptureFlagDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'captureFlag');
    },
    getAllObjects(variables?: GetAllObjectsQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetAllObjectsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetAllObjectsQuery>(GetAllObjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getAllObjects');
    },
    subscribeToAllObjects(variables?: SubscribeToAllObjectsSubscriptionVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SubscribeToAllObjectsSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubscribeToAllObjectsSubscription>(SubscribeToAllObjectsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'subscribeToAllObjects');
    },
    getPlayer(variables: GetPlayerQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetPlayerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPlayerQuery>(GetPlayerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPlayer');
    },
    mutateCurrentPlayer(variables: MutateCurrentPlayerMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<MutateCurrentPlayerMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<MutateCurrentPlayerMutation>(MutateCurrentPlayerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'mutateCurrentPlayer');
    },
    getScore(variables?: GetScoreQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetScoreQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetScoreQuery>(GetScoreDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getScore');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;